import { handleActions } from "redux-actions";

import { setNormalizers } from "./actions";

const initialState = {
    isLoadingNormalizers: false,
    codes: [],
    normalizers: {}
};

export const normalizersReducer = handleActions(
    {
        [setNormalizers]: (state, { payload }) => ({
            ...state,
            ...payload
        })
    },
    initialState
);